export enum TransportEventType {
    TransportOrder = 0,
    Product = 1,
    Vehicle = 2,
    Driver = 3
}

export const transportEventTypeNames: Readonly<Record<TransportEventType, string>> = Object.freeze({
    [TransportEventType.TransportOrder]: "transport.eventType.transportOrder",
    [TransportEventType.Product]: "transport.eventType.product",
    [TransportEventType.Vehicle]: "transport.eventType.vehicle",
    [TransportEventType.Driver]: "transport.eventType.driver",
});
